module.exports = __webpack_public_path__ + "static/img/pageThree.b8fb822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree.png
// module id = 2cff
// module chunks = 1